import {SpanIcon} from '@mazraeapp/react_icon_kit';
import cn from 'classnames';
import React, {useEffect, useState} from 'react';

type SearchBoxStyles = 'sm' | 'md' | 'lg';

interface ICustomSearchBoxProps extends React.HTMLProps<HTMLInputElement> {
  label?: string;
  inputValue: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  setInputValue: (values: string) => void;
  isAutofcus?: boolean;
  showRemoveIcon?: boolean;
  isFloating?: boolean;
  preIcon?: string;
  inputCustomClass?: string;
  customComponent?: () => JSX.Element;
  removeIcon?: string;
  removeIconClassName?: string;
  boxStyles?: SearchBoxStyles; // Renamed from 'size' to 'BoxStyles'
}

const CustomSearchBox = ({
  label,
  inputValue,
  onChange,
  setInputValue,
  isAutofcus,
  isFloating = true,
  preIcon = '',
  inputCustomClass = '',
  showRemoveIcon = true,
  customComponent,
  removeIcon = 'icon-nameremove-circle',
  removeIconClassName,
  boxStyles = 'md', // Renamed from 'size'
  ...props
}: ICustomSearchBoxProps) => {
  const [hasText, setHasText] = useState<boolean>(inputValue?.length > 0);
  const [startType, setStartType] = useState<boolean>(inputValue?.length > 0);

  useEffect(() => {
    setHasText(inputValue?.length > 0);
  }, [inputValue]);

  const heightClasses: Record<SearchBoxStyles, string> = {
    sm: 'min-h-10 text-sm',
    md: 'min-h-12',
    lg: 'min-h-14',
  };

  return (
    <div
      className={cn(
        'relative flex items-center bg-white',
        heightClasses[boxStyles],
        {
          'w-full rounded-lg border-[1px] overflow-hidden': inputCustomClass,
          'border-farm-shop-500': startType && hasText,
          'border-gray-400': !(startType && hasText),
        },
      )}
    >
      <label
        className={cn('flex bg-white transition-all w-fit align-items-center')}
      >
        {preIcon && (
          <SpanIcon className={cn('pr-2 text-xl text-gray-700', preIcon)} />
        )}
        {label}
      </label>

      <input
        {...props}
        value={inputValue}
        className={cn('pl-3 h-full outline-none', inputCustomClass, {
          'border-farm-shop-500': hasText,
          'pr-3': !preIcon,
        })}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          setStartType(true);
          onChange(e);
        }}
        onFocus={() => {
          setHasText(true);
        }}
        autoFocus={isAutofcus}
      />
      {customComponent && customComponent()}

      {startType && hasText && showRemoveIcon && (
        <i
          className={cn(
            'absolute left-3 top-1/2 text-gray-500 -translate-y-1/2 text-xxl',
            removeIcon,
            removeIconClassName,
          )}
          onClick={() => {
            setInputValue('');
          }}
        />
      )}
    </div>
  );
};

export default CustomSearchBox;
